export const brandPalette = {
  primary: {
    100: '#e0dff7',
    200: '#b8b5e8',
    300: '#8e8ad9',
    400: '#5e4db2', // main - desaturated, more professional (was #3d3bab)
    500: '#4a3a8f',
  },
  secondary: {
    100: '#e5dff3',
    200: '#c4b5e0',
    300: '#a38bcd',
    400: '#7a5fb5', // main - desaturated to match primary (was #6344a3)
    500: '#5e4a8c',
  },
  neutral: {
    100: '#ffffff',
    200: '#f8fafc',  // Slate-50: clean, bright background
    300: '#e2e8f0',  // Slate-200: subtle borders/dividers
    400: '#cbd5e1',  // Slate-300: muted UI elements
    500: '#94a3b8',  // Slate-400: secondary text
    600: '#64748b',  // Slate-500: tertiary text
    700: '#475569',  // Slate-600: strong text/icons
    800: '#1e293b',  // Slate-800: darkest elements
  },
  semantic: {
    red: { 100: '#fb3748', 200: '#EF233C' },
    yellow: { 100: '#ffdb43', 200: '#F2A900' },
    green: { 100: '#84ebb4', 200: '#26532B' },
  },
} as const;

export type ShadeScale = { 100: string; 200: string; 300?: string; 400?: string; 500?: string; 600?: string; 700?: string; 800?: string };

